import React from 'react';
import ReactDOM from 'react-dom';
import MapShuffle from './MapShuffle';
import './index.css';

ReactDOM.render(
  <MapShuffle />,
  document.getElementById('root')
);


// WEBPACK FOOTER //
// ./src/index.js